import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { NgbdSortableHeader } from 'app/tables/angular/sortable.directive';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {
  @Input() rows: any;
  @Input() term: '';
  currentPage = 1;
  pageSize = 8;
  closeResult = '';
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  count: any;
  collection: any;
  tagContent: any;
  tagData: any;
  password = ''
  p = 1;
  constructor(
    private apiService: StrapiApiService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private toast: ToastrService) {
  }

  ngOnInit(): void {
    const id = this.route.snapshot.params.id
    if (id) {
      this.getCollectionsByTag(id)
    } else if (this.rows) {
      this.count = this.rows.rb_collections.length
    }
  }

  open(content, data) {
    this.collection = data;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  detail(data: any) {
    let condition = false
    for (let i in data.rb_tags) {
      if (this.password === data.rb_tags[i].password_text) {
        var name = data.title
        name = name.toLowerCase();
        name = name.replace(/ /g, "-");
        name = name.replace(/\?/g, "-");
        this.modalService.dismissAll();
        if (!this.term) {
          this.router.navigate(['research-base/detail/', name, data.id, '~'])
        } else {
          this.router.navigate(['research-base/detail/', name, data.id, this.term])
        }
        condition = true
        localStorage.setItem('pt', '1')
      }
    } if (condition == false) {
      this.toast.error('incorrect password')
    }
    this.password = ''
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getCollectionsByTag(id) {
    this.apiService.getCollectionsbyId(id).subscribe((res: any) => {
      this.rows = res;
      this.count = this.rows.rb_collections.length
      if (!this.rows.rb_collections.length) {
        this.toast.info('No data found');
      }
    })
  }
}
